import {ServiceEventTicketPolicyEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {ServiceEventTicketPolicyAction} from "./ServiceEventTicketPolicyActionMenu";
import {useServiceEventTicketPolicyMutation} from "../../../hooks/useServiceEventTicketPolicyMutation";

export type UseServiceEventTicketPolicyActionProps = {}

export type UseServiceEventTicketPolicyActionResult = {
  onServiceEventTicketPolicyActionClick: (serviceEventTicketPolicy: ServiceEventTicketPolicyEntity, action: ServiceEventTicketPolicyAction) => void;
}

export const useServiceEventTicketPolicyAction = (props: UseServiceEventTicketPolicyActionProps = {}): UseServiceEventTicketPolicyActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteServiceEventTicketPolicy,
  } = useServiceEventTicketPolicyMutation()

  const _onServiceEventTicketPolicyActionClick = useCallback((serviceEventTicketPolicy: ServiceEventTicketPolicyEntity, action: ServiceEventTicketPolicyAction) => {
    if (action === "EDIT") {
      navigate(`/service-event-ticket-policies/form`, {state: {id: serviceEventTicketPolicy.id}})
    } else if (action === "DELETE") {
      deleteServiceEventTicketPolicy(serviceEventTicketPolicy.id, undefined)
    }
  }, [navigate, deleteServiceEventTicketPolicy])

  return {
    onServiceEventTicketPolicyActionClick: _onServiceEventTicketPolicyActionClick
  }
}
